// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
  height: 80vh;
  width: 100%;
  border: 3px solid #dcdcdc;
  border-radius: 15px;
  top: 0px;
}

h1 {
  font-size: 3rem;
  font-weight: 700;
  color: #037b8990;
  margin: 0 0 1.5rem;
}

i {
  font-size: 1.3rem;
}

a.btn {
  color: #fff;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  transition: all 0.2s;
}

a.btn:hover {
  background: #d73851;
  border: 1px solid #d73851;
  color: #fff;
}

.cover {
  padding: 20px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-form input[type="submit"] {
  color: #fff;
  padding: 0 30px;
  cursor: pointer;
  transition: all 0.2s;
  background: #027b9a;
  border: 0;
}

.flex-form input[type="submit"]:hover {
  background: #027b9a;
  border: 1px solid #004658;
}

.flex-form {
  display: flex;
  z-index: 10;
  position: relative;
  width: 500px;
  box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.3);
  background-color: #ffffff;
}

.flex-form > * {
  border: 0;
  padding: 0 0 0 10px;
  line-height: 50px;
  font-size: 1rem;
  border-radius: 0;
  outline: 0;
}

input[type="search"] {
  flex-basis: 500px;
  border: 2px solid #ffffff;
  background: #fff;
}

input[placeholder="Where do you want to go?"] {
  color: #027b9a;
}

#madeby {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 25px 100px;
  color: #fff;
}

@media all and (max-width: 800px) {
  body {
    font-size: 0.9rem;
  }

  .flex-form {
    width: 100%;
  }

  input[type="search"] {
    flex-basis: 100%;
  }

  .flex-form > * {
    font-size: 0.9rem;
  }

  h1 {
    font-size: 2rem;
  }

  .cover {
    padding: 20px;
  }

  #madeby {
    padding: 30px 20px;
  }

  #map {
    height: 100vh; /* Full height for mobile */
    border-radius: 8px; /* Smaller border radius for mobile */
  }
}

@media all and (max-width: 360px) {
  header nav li {
    margin: 0 10px;
  }

  .flex-form {
    flex-direction: column;
  }

  input[type="search"] {
    flex-basis: 0;
  }

  label {
    display: none;
  }
}

#layers-switcher {
  margin: 20px;
  right: 10px;
  display: inline-block;
  position: absolute;
  z-index: 1;
}

#layers-switcher select {
  padding: 10px 15px;
  font-size: 16px;
  border: 2px solid #ccc;
  border-radius: 8px;
  background-color: white;
  color: #333;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#layers-switcher select:hover {
  border-color: #777;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

#layers-switcher select:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
}

/* arrow dropdown icon customization */
#layers-switcher::after {
  content: "▼";
  font-size: 12px;
  color: #333;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  pointer-events: none;
}

/* Adjustments for mobile devices */
@media (max-width: 768px) {
  #layers-switcher select {
    width: 100%;
    padding: 12px;
    font-size: 18px;
  }
}

/* For large screens */
@media (min-width: 1200px) {
  .cover {
    padding: 50px 100px;
  }

  h1 {
    font-size: 4rem; /* Larger font size for bigger displays */
  }

  .flex-form input[type="submit"] {
    font-size: 1rem;
    padding: 10px 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/map.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa,EAAE,2BAA2B;IAC1C,kBAAkB,EAAE,qCAAqC;EAC3D;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["#map {\n  height: 80vh;\n  width: 100%;\n  border: 3px solid #dcdcdc;\n  border-radius: 15px;\n  top: 0px;\n}\n\n@import url('https://fonts.googleapis.com/css?family=Lato:400,700');\n\nh1 {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #037b8990;\n  margin: 0 0 1.5rem;\n}\n\ni {\n  font-size: 1.3rem;\n}\n\na.btn {\n  color: #fff;\n  padding: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  transition: all 0.2s;\n}\n\na.btn:hover {\n  background: #d73851;\n  border: 1px solid #d73851;\n  color: #fff;\n}\n\n.cover {\n  padding: 20px 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-form input[type=\"submit\"] {\n  color: #fff;\n  padding: 0 30px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #027b9a;\n  border: 0;\n}\n\n.flex-form input[type=\"submit\"]:hover {\n  background: #027b9a;\n  border: 1px solid #004658;\n}\n\n.flex-form {\n  display: flex;\n  z-index: 10;\n  position: relative;\n  width: 500px;\n  box-shadow: 4px 8px 16px rgba(0, 0, 0, 0.3);\n  background-color: #ffffff;\n}\n\n.flex-form > * {\n  border: 0;\n  padding: 0 0 0 10px;\n  line-height: 50px;\n  font-size: 1rem;\n  border-radius: 0;\n  outline: 0;\n}\n\ninput[type=\"search\"] {\n  flex-basis: 500px;\n  border: 2px solid #ffffff;\n  background: #fff;\n}\n\ninput[placeholder=\"Where do you want to go?\"] {\n  color: #027b9a;\n}\n\n#madeby {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 25px 100px;\n  color: #fff;\n}\n\n@media all and (max-width: 800px) {\n  body {\n    font-size: 0.9rem;\n  }\n\n  .flex-form {\n    width: 100%;\n  }\n\n  input[type=\"search\"] {\n    flex-basis: 100%;\n  }\n\n  .flex-form > * {\n    font-size: 0.9rem;\n  }\n\n  h1 {\n    font-size: 2rem;\n  }\n\n  .cover {\n    padding: 20px;\n  }\n\n  #madeby {\n    padding: 30px 20px;\n  }\n\n  #map {\n    height: 100vh; /* Full height for mobile */\n    border-radius: 8px; /* Smaller border radius for mobile */\n  }\n}\n\n@media all and (max-width: 360px) {\n  header nav li {\n    margin: 0 10px;\n  }\n\n  .flex-form {\n    flex-direction: column;\n  }\n\n  input[type=\"search\"] {\n    flex-basis: 0;\n  }\n\n  label {\n    display: none;\n  }\n}\n\n#layers-switcher {\n  margin: 20px;\n  right: 10px;\n  display: inline-block;\n  position: absolute;\n  z-index: 1;\n}\n\n#layers-switcher select {\n  padding: 10px 15px;\n  font-size: 16px;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  background-color: white;\n  color: #333;\n  appearance: none;\n  cursor: pointer;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n#layers-switcher select:hover {\n  border-color: #777;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n#layers-switcher select:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);\n}\n\n/* arrow dropdown icon customization */\n#layers-switcher::after {\n  content: \"▼\";\n  font-size: 12px;\n  color: #333;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* Adjustments for mobile devices */\n@media (max-width: 768px) {\n  #layers-switcher select {\n    width: 100%;\n    padding: 12px;\n    font-size: 18px;\n  }\n}\n\n/* For large screens */\n@media (min-width: 1200px) {\n  .cover {\n    padding: 50px 100px;\n  }\n\n  h1 {\n    font-size: 4rem; /* Larger font size for bigger displays */\n  }\n\n  .flex-form input[type=\"submit\"] {\n    font-size: 1rem;\n    padding: 10px 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
